import { Fragment } from 'react';
import { Chip } from '@mui/material';
import { useStyles } from '../../../themes';
import { paths, generateValidatedParamsUrl } from '../../../lib';
import { AssignmentIcon, DashboardIcon } from '../../../assets';
import { SidebarItem } from '../SidebarItem';

export function ScannerSidebar() {
  const { css } = useStyles();
  return (
    <Fragment>
      <SidebarItem
        to={generateValidatedParamsUrl(paths.MANAGE_PALLETS)}
        text='Home'
        icon={DashboardIcon}
      />
      <SidebarItem
        to={generateValidatedParamsUrl(paths.PROCESS_ORDER_HOME)}
        isActive={() =>
          window.location.pathname ===
          generateValidatedParamsUrl(paths.PROCESS_ORDER_HOME)
        }
        text={
          <span>
            Process Order{' '}
            <Chip
              size='small'
              label='Beta'
              classes={{ label: css({ fontSize: '10px !important' }) }}
            />
          </span>
        }
        icon={AssignmentIcon}
      />
    </Fragment>
  );
}
